import { JsonConverter, JsonCustomConvert } from 'json2typescript';

import { ClientRelation } from '../../../../../core';

@JsonConverter
export class ClientRelationAdapter implements JsonCustomConvert<ClientRelation | undefined> {
    serialize(type: ClientRelation): any | undefined {
        return type ? String(type) : undefined;
    }

    deserialize(type: any): ClientRelation | undefined {
        switch (type) {
            case 'Holder':
                return ClientRelation.HOLDER;
            case 'Authorised':
                return ClientRelation.AUTHORIZED;
            default:
                return undefined;
        }
    }
}
